/* eslint-disable */
import * as React from "react";
import { createStyles, WithStyles, withStyles } from "@material-ui/styles";
import { Theme, Typography, IconButton } from "@material-ui/core";
import cn from "classnames";

import ArrowLeft from "@material-ui/icons/ArrowLeft";
import ArrowRight from "@material-ui/icons/ArrowRight";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      height: 52,
      userSelect: "none"
    },
    labelText: {
      fontSize: theme.typography.fontSize,
    },
    button: {
      height: 42,
      width: 42,
      color: theme.palette.common.black,
      "&.Mui-disabled": {
        color: theme.palette.action.disabled,
      },
    },
    buttonIcon: {
      height: 18,
      width: 18,
    },
  });

type DimensionValue = any;
type DimensionItem = Record<string, DimensionValue>;

export type DimSliderProps = {
  selectedIndex: number;
  className?: string;
  dimValues: DimensionItem[];
  onClick?: () => void;
  onNext?: () => void;
  onPrevious?: () => void;
  onChange?: (value: string) => void;
  idAttribute?: string;
  nameAttribute?: string;
};

type Props = DimSliderProps & WithStyles<typeof styles>;

class DimSlider extends React.Component<Props> {
  render() {
    const { classes, dimValues, selectedIndex, className, onClick } = this.props;
    const dimValue = dimValues[selectedIndex];
    return (
      <div className={cn(classes.root, className)} >
        <IconButton
          disabled={selectedIndex === 0}
          onClick={this.handleClickPrevious}
          classes={{
            root: classes.button,
          }}
        >
          <ArrowLeft classes={{
            root: classes.buttonIcon
          }}/>
        </IconButton>
        <Typography onClick={onClick} classes={{
          root: classes.labelText,
        }}>
          {dimValue && dimValue.name}
        </Typography>
        <IconButton
          disabled={selectedIndex === dimValues.length - 1}
          onClick={this.handleClickNext}
          classes={{
            root: classes.button,
          }}
        >
          <ArrowRight classes={{
            root: classes.buttonIcon
          }}/>
        </IconButton>
      </div>
    );
  }

  handleClickNext = () => {
    const { onNext, onChange, dimValues, selectedIndex } = this.props;
    if (onNext) {
      onNext();
    }

    if (onChange) {
      onChange(dimValues[selectedIndex + 1].id);
    }
  };

  handleClickPrevious = () => {
    const { onPrevious, onChange, dimValues, selectedIndex } = this.props;
    if (onPrevious) {
      onPrevious();
    }

    if (onChange) {
      onChange(dimValues[selectedIndex - 1].id);
    }
  };
}

export default withStyles(styles)(DimSlider);
